import { Component } from 'react';
import { Router } from '../react-router';
import { createBrowserHistory as createHistory } from '../history';
import warning from '../tiny-warning';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The public API for a <Router> that uses HTML5 history.
 */
class BrowserRouter extends Component {
  constructor(...args) {
    super(...args);
    this.history = createHistory(this.props);
  }
  render() {
    return /*#__PURE__*/_jsx(Router, {
      history: this.history,
      children: this.props.children
    });
  }
}
if (process.env.NODE_ENV !== 'production') {
  BrowserRouter.prototype.componentDidMount = function () {
    warning(
    // @ts-expect-error dev warning for accidental history prop — intentionally not in BrowserRouterProps
    !this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };
}
export default BrowserRouter;